import React from 'react'

import { Grid } from "@material-ui/core";
import { TextValidator } from "react-material-ui-form-validator";

export const CotizacionesForm = ({formValues, handleInputChange}) => {
  return (
    <>
        <Grid item xs={4}>
            <TextValidator
              variant="outlined"
              margin='normal'
              fullWidth
              label="Número Cotización"
              autoComplete="off"
              name="idCotizacion"
              value={formValues.idCotizacion}
              onChange={handleInputChange}
              type='number'
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <TextValidator
              variant="outlined"
              margin='normal'
              fullWidth
              label="Valor Cotización"
              autoComplete="off"
              name="valorCotizacion"
              value={formValues.valorCotizacion}
              type='number'
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
              disabled
            />
          </Grid>
          <Grid item xs={4}>
            <TextValidator
              variant="outlined"
              margin='normal'
              fullWidth
              label="Número Afiliado"
              autoComplete="off"
              name="idAfiliado"
              value={formValues.idAfiliado}
              type='number'
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
              disabled
            />
          </Grid>
    </>
  )
}
